import { Observable, combineLatest, map, switchMap } from 'rxjs';
import { persistentWorkspaces$ as allWorkspaces$ } from 'streams/workspaces/workspaces$';
import { getTabularMappingStream } from '../tabularMappings/getTabularMappingStream';
import { extractUsedWorkspaces } from './util';
import { integrationId$ } from '../integrationId/integrationId$';
import { workspaceAccessControlInterface } from 'resourcePermissions/accessControlHelpers/workspace';
import { currentUserPermissionContext$ } from 'streams/currentUserPermissions/currentUserPermissionContext$';
import { OrgWorkspaceWithWritePermissions } from './types';

export const existingWorkspaces$: Observable<
  OrgWorkspaceWithWritePermissions[]
> = combineLatest([allWorkspaces$, currentUserPermissionContext$]).pipe(
  map(([{ byId, sortIds }, permissionContext]) => {
    return sortIds.map(id => ({
      ...byId[id],
      hasEditAccess: workspaceAccessControlInterface.canEditWorkspace(
        permissionContext,
        id,
        null
      ),
    }));
  })
);

const usedWorkspaces$ = integrationId$.pipe(
  switchMap(integrationId => {
    return getTabularMappingStream(integrationId);
  }),
  map(extractUsedWorkspaces)
);

export const workspaces$ = combineLatest([
  existingWorkspaces$,
  usedWorkspaces$,
]).pipe(
  map(([existing, used]) => ({
    used,
    existing,
  }))
);
